module.exports = __webpack_public_path__ + "img/competencies_swiper_03.32f2dceb.jpg";